import { reactive } from 'vue'

// 全局错误状态接口
export interface GlobalErrorState {
  isVisible: boolean
  title: string
  message: string
  timestamp: number
}

// 全局错误状态
const globalErrorState = reactive<GlobalErrorState>({
  isVisible: false,
  title: '',
  message: '',
  timestamp: 0
})

// 当前显示的错误消息，用于防重复
let currentErrorMessage = ''

export function useGlobalError() {
  /**
   * 显示全局错误提示
   * @param title 错误标题
   * @param message 错误消息
   */
  const showGlobalError = (title: string, message: string) => {
    // 如果当前正在显示相同的错误消息，则不重复显示
    if (currentErrorMessage === message && globalErrorState.isVisible) {
      return
    }

    // 记录当前错误消息
    currentErrorMessage = message

    // 显示错误提示
    globalErrorState.isVisible = true
    globalErrorState.title = title
    globalErrorState.message = message
    globalErrorState.timestamp = Date.now()
  }

  /**
   * 隐藏全局错误提示
   */
  const hideGlobalError = () => {
    globalErrorState.isVisible = false
    // 延迟清除消息，避免在动画过程中被重新触发
    setTimeout(() => {
      currentErrorMessage = ''
    }, 300)
  }

  /**
   * 显示API错误 - 通用的API错误处理
   * @param error 错误对象或错误消息
   * @param title 可选的错误标题，默认为"操作失败"
   */
  const showApiError = (error: any, title: string = '操作失败') => {
    let message = '服务器错误，请稍后重试'

    if (typeof error === 'string') {
      message = error
    } else if (error?.message) {
      message = error.message
    } else if (error?.response?.data?.message) {
      message = error.response.data.message
    }

    showGlobalError(title, message)
  }

  /**
   * 显示网络错误
   */
  const showNetworkError = () => {
    showGlobalError('网络错误', '网络连接失败，请检查网络设置后重试')
  }

  /**
   * 显示权限错误
   */
  const showPermissionError = () => {
    showGlobalError('权限不足', '您没有执行此操作的权限，请联系管理员')
  }

  return {
    // 状态
    globalErrorState,

    // 方法
    showGlobalError,
    hideGlobalError,
    showApiError,
    showNetworkError,
    showPermissionError
  }
}
